const gradient = {
  lightest: "rgba(0,0,0,0.1)",
  lighter: "rgba(0,0,0,0.05)",
  darkLightest: "rgba(255,255,255,0.1)",
  darkLighter: "rgba(255,255,255,0.05)",
};

// Styled-components passes the full theme object; "dark" is kept for callers
// that pass the theme name.
const isDarkTheme = (theme) => theme === "dark" || theme?.isDark === true;

const stops = (theme) => ({
  edge: isDarkTheme(theme) ? gradient.darkLightest : gradient.lightest,
  mid: isDarkTheme(theme) ? gradient.darkLighter : gradient.lighter,
});

export const circleGradient = (theme) => {
  const { edge, mid } = stops(theme);
  return `linear-gradient(to right, ${edge} 5%, ${mid} 65%, ${edge} 70% )`;
};

export const lineGradient = (theme) => {
  const { edge, mid } = stops(theme);
  return `linear-gradient(to right, ${edge} 5%, ${mid} 12%, ${edge} 55% )`;
};
